module.exports = new __parcel__URL__("buckley-coding.00e799c3.png").toString();